export default __webpack_public_path__ + "static/O0144-196d39f3b00dccfd6eaea778fd33640d.png";